<div class="table-responsive" [class.overflow-hidden]="settingsParkingPassesService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
        <tr [ngClass]="{'noSort': settingsParkingPassesService.parkingPassesData['rules'].data.length < 2}">
            <th></th>
            <th (click)="orderBy('internalId', $event)">ID<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('name', $event)">Rule Name<span class="footable-sort-indicator"></span></th>
            <th *ngIf="settingsParkingPassesService.buildings.length > 1">Parking Lots</th>
            <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">
                Created On <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('createdBy.fullName', $event)">
                Created By <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('enableStatus', $event)">Status<span class="footable-sort-indicator"></span></th>
            <th *ngIf="settingsParkingPassesService.canDelete()">Actions</th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-item [ngForOf]="settingsParkingPassesService.parkingPassesData['rules'].data" let-index="index">
            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.internalId}}</td>
                <td>{{item.name}}</td>
                <td *ngIf="settingsParkingPassesService.buildings.length > 1">
                    <span *ngFor="let lot of item.parkingLots; let last = last;">
                        {{lot.name}}
                        <span *ngIf="!last">,</span>
                    </span>
                </td>
                <td>{{item.createdAt | mccDate:true:true}}</td>
                <td>{{item.createdBy}}</td>
                <td>
                    <span *ngIf="item.enableStatus" class="text-uppercase label label-active">Active</span>
                    <span *ngIf="!item.enableStatus"  class="text-uppercase label label-inactive">Inactive</span>
                </td>
                <td *ngIf="settingsParkingPassesService.canDelete()" class="td-action-btn">
                    <div class="input-group-btn btn-in-table input-group">
                        <button (click)="deleteAmenity(item, $event)" class="btn btn-white btn-xs delete-button">
                            Delete
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <tr *ngFor="let item of settingsParkingPassesService.emptyRowService.emptyRow" style="cursor: default;">
            <td></td><td>&nbsp;</td><td *ngIf="settingsParkingPassesService.buildings.length > 1"></td><td></td><td></td>
            <td *ngIf="settingsParkingPassesService.canDelete()"></td><td></td><td></td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="settingsParkingPassesService.parkingPassesData['rules'].total == 0 && !settingsParkingPassesService.showServiceUnavailable"
        class="text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <h2 *ngIf="settingsParkingPassesService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes-rules-list/settings-parking-passes-rules-list.component.html